<template>
  <div class="ui segment">
    <h2>Paid Shrpa Creator Visit</h2>
    <h3 style="display: inline; margin-top: 5px">{{ collab.communityName }} - {{ collab.collabName }}</h3>
    <SrpButton class="view-collab-button" size="tiny" @click="emit('click:viewCollab')">View Creator Visit</SrpButton>
    <div style="font-size: 1.1em; margin-top: 15px">
      <LinkWithIcon tag="a" :href="Links.ExternalLinks.CreatorCollabAdvExp" target="_blank" color="blue">
        <template #icon>
          <IconEmbedded name="external-link_2" />
        </template>
        <span>Shrpa's Creator Visit expectations</span>
      </LinkWithIcon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CreatorCollabSummary } from "@contracts/collab";
import Links from "@logic/ExternalLinks";
import SrpButton from "@components/ui/SrpButton.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineProps<{
  collab: CreatorCollabSummary;
}>();
const emit = defineEmits<{
  (e: "click:viewCollab"): void;
}>();
</script>

<style scoped lang="scss">
.view-collab-button {
  margin-inline-start: 15px;
}
</style>
